// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedService {
  Blog: {"enum_constant":"Blog"};
  DailyNews: {"enum_constant":"DailyNews"};
  LiveLessons: {"enum_constant":"LiveLessons"};
  LiveLessonsB2B: {"enum_constant":"LiveLessonsB2B"};
  LiveLessonsB2S: {"enum_constant":"LiveLessonsB2S"};
  QandA: {"enum_constant":"QandA"};
  StudyAbroad: {"enum_constant":"StudyAbroad"};
  Tutor: {"enum_constant":"Tutor"};
  Words: {"enum_constant":"Words"};
  iKnow: {"enum_constant":"iKnow"};
}

export type ServiceId = keyof IParsedService;
export type ServiceData = IParsedService[ServiceId];
const data: ServiceData[] = [{"enum_constant":"Blog"},{"enum_constant":"DailyNews"},{"enum_constant":"LiveLessons"},{"enum_constant":"LiveLessonsB2B"},{"enum_constant":"LiveLessonsB2S"},{"enum_constant":"QandA"},{"enum_constant":"StudyAbroad"},{"enum_constant":"Tutor"},{"enum_constant":"Words"},{"enum_constant":"iKnow"}];
export default data;
